// .nautilus-label
// field-info (data-set)
// #app-debug

export class ShowInfoLabel {
	public static isChangeTextArae: boolean = false;
	public static create() {
		const appDebug: HTMLElement = document.getElementById("app-debug");
		if (appDebug) {
			const labels = Array.prototype.slice.call(document.querySelectorAll("label.nautilus-label"));
			for (let label of labels) {
				label.addEventListener("dblclick", ShowInfoLabel.textaraeHandler);
			}
		}
	}
	public static createTextArae(target: any, clientX: number, clientY: number) {
		let textarae = document.createElement("textarea");
		let container = document.createElement("div");
		let closeBtn = document.createElement("button");
		let title = document.createElement("span");
		let body = document.getElementsByTagName("body");

		container.style.cssText = `width:15%; height:auto; position: fixed; background-color: rgba(64, 74, 74, 0.78); padding: 10px;`;
		container.style.top = `${clientY}px`;
		container.style.left = `${clientX}px`;

		if (body[0]) {
			setTimeout(() => {
				const clientHeightFromBody = body[0].clientHeight; // top
				const clientWidthFromBody = body[0].clientWidth; // left

				const heightFromContainer = parseInt(window.getComputedStyle(container).getPropertyValue("height"));
				const widthFromContainer = parseInt(window.getComputedStyle(container).getPropertyValue("width"));
				const topFromContainer = parseInt(window.getComputedStyle(container).getPropertyValue("top"));
				const leftFromContainer = parseInt(window.getComputedStyle(container).getPropertyValue("left"));

				if ((heightFromContainer + topFromContainer) > clientHeightFromBody) {
					container.style.top = `${clientHeightFromBody - heightFromContainer - 20}px`;
				}

				if ((widthFromContainer + leftFromContainer) > clientWidthFromBody) {
					container.style.left = `${clientWidthFromBody - widthFromContainer - 20}px`;
				}
			}, 0);
		}

		closeBtn.textContent = `x`;
		closeBtn.style.cssText = `width: 15px; height: 15px;`;
		closeBtn.addEventListener("click", ShowInfoLabel.closeBtnEventHandler);

		title.textContent = target.textContent;
		title.style.cssText = `color: #fff; font-weight: bold; font-size: 16px; margin-left: 15px;`;

		let text = target.title;
		let contentArr = text.split("\n");
		contentArr = contentArr[0].split("//");

		let content = `Class: ${contentArr[0]}\nFeld in Db: ${contentArr[1]}\nProperty: ${contentArr[2]}`;

		textarae.textContent = (contentArr.length === 3) ? content : `Es gibt keine Metadaten zu diesem Feld.`;
		textarae.style.cssText = `width: 100%; height: 100px; border: 1px solid #048484; box-sizing: border-box; font-size: 13px; color: red; padding: 5px;`;

		container.append(closeBtn);
		container.append(title);
		container.append(textarae);
		container.id = `id-close`;

		document.querySelector("main").appendChild(container);
		ShowInfoLabel.isChangeTextArae = true;
	}

	public static textaraeHandler(e: any) {
		e.preventDefault();
		const target: string = e.target;
		const clientX: number = e.clientX;
		const clientY: number = e.clientY;

		if (!ShowInfoLabel.isChangeTextArae) {
			ShowInfoLabel.createTextArae(target, clientX, clientY);
		}
	}

	public static closeBtnEventHandler(e: any) {
		e.preventDefault();
		const idClose = document.getElementById("id-close");
		idClose.remove();
		ShowInfoLabel.isChangeTextArae = false;
	}
}